import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type CappedAmountUpdateMutationVariables = Types.Exact<{
  cappedAmount: Types.Scalars['Decimal']['input'];
  shopPlatformID: Types.Scalars['ID']['input'];
  redirectURL?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type CappedAmountUpdateMutationResponse = Pick<Types.Mutation, 'cappedAmountUpdate'>;

export const CappedAmountUpdateDocument = `
    mutation CappedAmountUpdate($cappedAmount: Decimal!, $shopPlatformID: ID!, $redirectURL: String) {
  cappedAmountUpdate(
    cappedAmount: $cappedAmount
    shopPlatformID: $shopPlatformID
    redirectURL: $redirectURL
  )
}
    `;

export const useCappedAmountUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CappedAmountUpdateMutationResponse,
    TError,
    CappedAmountUpdateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CappedAmountUpdateMutationResponse,
    TError,
    CappedAmountUpdateMutationVariables,
    TContext
  >(
    ['CappedAmountUpdate'],
    (variables?: CappedAmountUpdateMutationVariables) =>
      appFetcher<CappedAmountUpdateMutationResponse, CappedAmountUpdateMutationVariables>(
        CappedAmountUpdateDocument,
        variables,
      )(),
    options,
  );
};

useCappedAmountUpdateMutation.getKey = () => ['CappedAmountUpdate'];
